import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class PublicCartCheckoutResponse {
  @jsonMember(String)
  public readonly orderId!: Guid;

  @jsonMember(String)
  public readonly accessToken!: string;
}
